import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "./api";
import { useBT } from "./i18n";
import { Input } from "../components/ui/input";
import { PhoneInput } from "./PhoneInput";
import { BellRing, Loader2, CheckCircle2 } from "lucide-react";

export const WaitlistForm = ({ service, date }) => {
  const { t, lang } = useBT();
  const [f, setF] = useState({ name: "", email: "", cc: "+30", phone: "", guests: 2 });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/api/public/waitlist", {
        service_id: service.id, date, name: f.name, email: f.email,
        phone: `${f.cc} ${f.phone}`, guests: Number(f.guests), language: lang,
      });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) return (
    <p className="mt-5 flex items-center gap-2 text-sm text-emerald-700" data-testid="waitlist-success">
      <CheckCircle2 size={16} /> {t.wlDone}
    </p>
  );

  return (
    <form onSubmit={submit} className="mt-5 bg-white border rounded-xl p-5 space-y-3 max-w-md" data-testid="waitlist-form">
      <p className="flex items-center gap-2 font-medium"><BellRing size={16} className="text-[#b09873]" /> {t.wlTitle}</p>
      <p className="text-xs text-[#1d2b31]/60">{t.wlDesc}</p>
      <Input required minLength={2} placeholder={t.name} value={f.name} onChange={set("name")} data-testid="waitlist-name" />
      <Input required type="email" placeholder={t.email} value={f.email} onChange={set("email")} data-testid="waitlist-email" />
      <PhoneInput cc={f.cc} phone={f.phone} onCc={set("cc")} onPhone={set("phone")} testid="waitlist" />
      <Input required type="number" min={1} max={30} value={f.guests} onChange={set("guests")} aria-label={t.guests} data-testid="waitlist-guests" />
      <button type="submit" disabled={busy} data-testid="waitlist-submit"
        className="w-full inline-flex justify-center items-center gap-2 bg-[#15262d] text-white text-xs uppercase tracking-[0.2em] px-6 py-3 rounded-sm hover:bg-[#b09873] transition-colors disabled:opacity-60">
        {busy && <Loader2 size={14} className="animate-spin" />} {t.wlJoin}
      </button>
    </form>
  );
};
